import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Form from 'components/organisms/Forms/Form/Form';

const StyledInlineForm = styled(Form)`
  ${ComponentStyles}
`;

StyledInlineForm.propTypes = {
  theme: PropTypes.object
};

export default StyledInlineForm;
